import React from 'react';
import { Textarea } from '../../../../ui/components/Textarea';

interface DescriptionInputProps {
    value: string;
    onChange: (value: string) => void;
}

const DescriptionInput: React.FC<DescriptionInputProps> = ({ value, onChange }) => {
    return (
        <div className="space-y-2">
            <label className="text-xs text-gray-500">description (optional)</label>
            <Textarea
                name="description"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Add any notes about your coffee experience..."
                rows={3}
            />
        </div>
    );
};

export default DescriptionInput;


